import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.wrappedWriter_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.uploads_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      }
      collectedUploads_cst71z_k$() {
        return this.uploads_1;
      }
      beginArray_hxn19s_k$() {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.beginArray_hxn19s_k$();
        return this;
      }
      endArray_s2tmpq_k$() {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.endArray_s2tmpq_k$();
        return this;
      }
      beginObject_5wddq0_k$() {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.beginObject_5wddq0_k$();
        return this;
      }
      endObject_ofuv3u_k$() {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.endObject_ofuv3u_k$();
        return this;
      }
      name_i73qwh_k$(name) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.name_i73qwh_k$(name);
        return this;
      }
      value_hphtnt_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_hphtnt_k$(value);
        return this;
      }
      value_z3qus4_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_z3qus4_k$(value);
        return this;
      }
      value_pfghfv_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_pfghfv_k$(value);
        return this;
      }
      value_2irneh_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_2irneh_k$(value);
        return this;
      }
      value_hdgek3_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_hdgek3_k$(value);
        return this;
      }
      value_pycfpt_k$(value) {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.value_pycfpt_k$(value);
        return this;
      }
      value_bxcuou_k$(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.uploads_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.wrappedWriter_1.get_path_wos8ry_k$();
        tmp0.put_4fpzoq_k$(key, value);
        this.wrappedWriter_1.nullValue_h3u4a2_k$();
        return this;
      }
      nullValue_h3u4a2_k$() {
        // Inline function 'kotlin.apply' call
        this.wrappedWriter_1.nullValue_h3u4a2_k$();
        return this;
      }
      get_path_wos8ry_k$() {
        return this.wrappedWriter_1.get_path_wos8ry_k$();
      }
      close_yn9xrc_k$() {
        this.wrappedWriter_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
